import React, { memo } from "react";

interface BatteryIndicatorProps {
  percent: number | null | undefined;
}

export type BatteryColor = "green" | "yellow" | "red";

export function clampPercent(raw: number | null | undefined): number {
  if (raw == null || isNaN(raw as number)) return 0;
  return Math.min(100, Math.max(0, raw));
}

// 0 -> 0 bars, 1-25 -> 1, 26-50 -> 2, 51-75 -> 3, 76-100 -> 4
export function percentToBars(percent: number): number {
  return Math.min(4, Math.max(0, Math.floor((percent + 24) / 25)));
}

export function getColor(percent: number): BatteryColor {
  if (percent >= 40) return "green";
  if (percent >= 20) return "yellow";
  return "red";
}

const FILL_COLORS: Record<BatteryColor, string> = {
  green: "#2e7d32",
  yellow: "#f9a825",
  red: "#c62828",
};

const BAR_X = [4, 20.75, 37.5, 54.25];

export const BatteryIndicator = memo<BatteryIndicatorProps>(({ percent }) => {
  const clamped = clampPercent(percent);
  const bars = percentToBars(clamped);
  const color = getColor(clamped);
  const fill = FILL_COLORS[color];

  return (
    <svg
      width="77"
      height="32"
      viewBox="0 0 77 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="battery-indicator"
      data-bars={bars}
      data-color={color}
    >
      {BAR_X.slice(0, bars).map((x) => (
        <rect
          key={x}
          opacity="0.4"
          x={x}
          y="4"
          width="14.75"
          height="24"
          fill={fill}
        />
      ))}
      <rect x="0.5" y="0.5" width="72" height="31" stroke="#D1D1D1" />
      <rect x="73" y="12" width="4" height="8" fill="#D1D1D1" />
    </svg>
  );
});

BatteryIndicator.displayName = "BatteryIndicator";
